import { FC, HTMLProps, useReducer } from 'react';

import Slider from 'react-slick';
import { ReactSVG } from 'react-svg';

import { i18n as I18n } from 'utils/i18n';
import { Venue } from 'hooks/useVenue';
import LocationMap from '../locationMap';

type ButtonProps = HTMLProps<HTMLButtonElement>;

const NextBtn: FC<ButtonProps> = ({ children = <>&#10095;</>, ...props }) => {
  return <button {...props}>{children}</button>;
};

const PrevBtn: FC<ButtonProps> = ({ children = <>&#10094;</>, ...props }) => {
  return <button {...props}>{children}</button>;
};

type View = 'slides' | 'map';

interface Props {
  slideUrls: string[];
  mapLatLng?: Venue['latLng'];
  initialView?: View;
}

const icons = {
  location: '../../../images/icons/rooms-properties/location.svg',
  pictures: '../../../images/icons/rooms-properties/property-pictures.svg',
};

const settings = {
  dots: false,
  infinite: true,
  fade: true,
  duration: 1000,
  nextArrow: <NextBtn />,
  prevArrow: <PrevBtn />,
};

type Toggle = (prev: boolean) => boolean;
interface InitialiserArg {
  view: View;
  latLng?: Venue['latLng'];
}

const SlideShow: FC<Props> = ({
  slideUrls = [],
  mapLatLng,
  initialView = 'slides',
}) => {
  const [mapIsDisplayed, toggleView] = useReducer<Toggle, InitialiserArg>(
    state => !state,
    { view: initialView, latLng: mapLatLng },
    ({ view, latLng }) => !!latLng && view === 'map'
  );

  const slides = slideUrls
    .filter(url => !!url)
    .map(url => (
      <div className="slide" key={url}>
        <span style={{ backgroundImage: `url(${url})` }} />
      </div>
    ));

  return (
    <>
      {mapLatLng && mapIsDisplayed && (
        <LocationMap lat={mapLatLng.lat} lng={mapLatLng.lng} />
      )}
      {!mapIsDisplayed && (
        <div className="slideshow__container" data-testid="slider">
          <Slider {...settings}>{slides}</Slider>
        </div>
      )}
      {mapLatLng && (
        <>
          <button
            className="slideshow__map-toggle-btn slideshow__map-toggle-btn__desktop button button--primary"
            onClick={toggleView}
          >
            {I18n.t(
              mapIsDisplayed ? 'slideshow.view_photos' : 'slideshow.view_on_map'
            )}
          </button>
          <button
            className="slideshow__map-toggle-btn slideshow__map-toggle-btn__mobile button button--primary"
            onClick={toggleView}
          >
            <ReactSVG
              className="slideshow__svg"
              src={mapIsDisplayed ? icons.pictures : icons.location}
            />
          </button>
        </>
      )}
    </>
  );
};

export default SlideShow;
